{
  "version": 1,
  "asset_id": "287e23a9-06c2-458b-92f2-361510e4cddc",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/287e23a9-06c2-458b-92f2-361510e4cddc/interior-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/287e23a9-06c2-458b-92f2-361510e4cddc/interior-thumb.webp",
  "original_filename": "interior-thumb.webp",
  "size": 6840,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:43Z"
}
